<template>
    <div id="patients-portal-form">
        <div class="page-height">
            <b-row>
                <b-col class="col-12">
                    <MdTitleRegInfo
                        v-if="!isAllPatientsMode"
                        v-bind:RegistrationInfo="PatientTitle"
                        v-bind:titlePrefix="$t('PPDbClaims.Title')"
                        v-bind:titleRef="'titleElementPatientClaims'"
                        v-bind:patientCode="patientCode"
                    >
                    </MdTitleRegInfo>
                    <MdTitle
                        v-else
                        v-bind:Text="$t('PPDbClaims.Title')"
                        v-bind:Name="'titleElementPatientClaims'"
                    />

                    <div
                        class="alert alert-fill-warning d-flex align-items-center m-3"
                        role="alert"
                        v-if="isReadOnly"
                    >
                        <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                        <div class="flex-grow-1">
                            <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12">
                    <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                        <div
                            class="tab-content tab-content-custom-pill"
                            id="pills-tabContent-custom"
                        >
                            <div
                                class="tab-pane fade show active"
                                id="claimsSearchCriteria"
                                role="tabpanel"
                            >
                                <b-row class="mt-3">
                                    <b-col lg="3" md="3" sm="12">
                                        <MdDateTime
                                            :Label="$t('Shared.datefrom')"
                                            :Model="parameters.dateFrom"
                                            @input="parameters.dateFrom = $event"
                                            :Id="'TestOrderDateFrom'"
                                            :Type="'date'"
                                            :isRequired="false"
                                            :OnPressEnter="searchClaims"
                                            :isConfirm="false"
                                            :ReadOnly="false"
                                            :isValid="isDateFromValid"
                                        >
                                        </MdDateTime>
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdDateTime
                                            :Label="$t('Shared.dateTo')"
                                            :Model="parameters.dateTo"
                                            @input="parameters.dateTo = $event"
                                            :Id="'TestOrderDateTo'"
                                            :Type="'date'"
                                            :isRequired="false"
                                            :OnPressEnter="searchClaims"
                                            :isConfirm="false"
                                            :ReadOnly="false"
                                            :isValid="isDateToValid"
                                        >
                                        </MdDateTime>
                                    </b-col>
                                    <b-col v-if="isAllPatientsMode" lg="3" md="3" sm="12">
                                        <MdLookupMultiSelect
                                            v-bind:Label="$tc('Shared.Patient', 2)"
                                            v-bind:ModelCode="patientCodeModel"
                                            v-bind:RefCode="'patientcode'"
                                            v-bind:Api="'Patients'"
                                            v-bind:FieldCode="'patientcode'"
                                            v-bind:FieldDescription="'firstname'"
                                            :SearchTitle="$tc('Shared.Patient', 2)"
                                            :GetValues="getPatientValues"
                                            :InvalidFeedback="$t('Msg.InvalidCode')"
                                            :SearchFieldCode="'PatientCode'"
                                            :AuxFields="patientAuxFields"
                                            :FieldsDate="patientFieldsDate"
                                            :ServerSidePagination="true"
                                            v-bind:Fields="patientLookupFields"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdLookupMultiSelect
                                            v-bind:Label="$t('HouseFile.PrimaryInsurances')"
                                            v-bind:ModelCode="insuranceCodeModel"
                                            v-bind:RefCode="'InsuranceCode'"
                                            v-bind:Api="'Insurances/Lookup'"
                                            v-bind:FieldCode="'code'"
                                            v-bind:FieldDescription="'description'"
                                            :SearchTitle="$t('HouseFile.PrimaryInsurances')"
                                            :GetValues="getInsuranceValues"
                                            :InvalidFeedback="$t('Msg.InvalidCode')"
                                            :ServerSidePagination="true"
                                            v-bind:Fields="insuranceLookupFields"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <div class="tab-pane fade" id="claimsVisibilityFilters" role="tabpanel">
                                <b-row class="mt-3">
                                    <b-col lg="3" md="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('Shared.HZBalance')"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="parameters.hideZeroBalance"
                                            v-on:change="changeCheckbox"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('PatientClaimList.HideVoid')"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="parameters.hideVoid"
                                            v-on:change="changeCheckbox"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('PPDbClaims.HideShowInPortal')"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="parameters.hideShowInPortal"
                                            v-on:change="changeCheckbox"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                            <div
                                class="tab-pane fade"
                                id="claimsPaymentStatusFilters"
                                role="tabpanel"
                            >
                                <b-row class="mt-3">
                                    <b-col lg="3" md="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('PPDbClaims.PrimaryPaid')"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="parameters.primaryPaid"
                                            v-on:change="changeCheckbox"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('PPDbClaims.SecondaryPaid')"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="parameters.secondaryPaid"
                                            v-on:change="changeCheckbox"
                                        />
                                    </b-col>
                                    <b-col lg="3" md="3" sm="12">
                                        <MdCheckBox
                                            v-bind:Label="$t('PPDbClaims.TertiaryPaid')"
                                            v-bind:ClassProp="'AlignCheck'"
                                            v-bind:CheckedValue="true"
                                            v-bind:UncheckedValue="false"
                                            v-model="parameters.tertiaryPaid"
                                            v-on:change="changeCheckbox"
                                        />
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </MdTabList>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12">
                    <div class="text-center text-md-right mt-3">
                        <button
                            v-on:click="searchClaims"
                            type="button"
                            class="btn btn-primary btn-login mx-2 pull-right"
                        >
                            {{ $t('Shared.Search') }}
                        </button>
                    </div>
                </b-col>
            </b-row>

            <MdTitle
                v-bind:Text="$t('Shared.SearchResult')"
                v-bind:isSubtitle="true"
                v-bind:Name="'T_TitleSearch'"
            />

            <b-row>
                <b-col class="col-12 mt-2">
                    <MdTable
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="showMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:VisibleEditIcon="true"
                        v-bind:FieldsDate="fieldsDateArr"
                        :pageChanged="pageChanged"
                        :perPageFunction="perPageFunction"
                        v-bind:multiSelect="true"
                        v-bind:ShowSelectAll="true"
                        v-bind:ShowSelectedCount="true"
                        v-bind:ShowSearchCriteria="true"
                        v-bind:SelectionKey="'recId'"
                        v-bind:SelectAllFunction="getAllClaimsForSelectAll"
                        :onSearchCriteria="onSearchCriteriaChanged"
                        @selectionChanged="selectionChanged"
                        :customActionButtons="customActionButtons"
                        :isReadOnly="isReadOnly"
                        ref="claimsTable"
                    >
                        <template #cell-showInPatientPortalTranslated="{ cell }">
                            <span v-if="cell.data.showInPatientPortal" class="DocumentExpired">
                                {{ cell.data.showInPatientPortalTranslated }}
                            </span>
                            <span v-else>{{ cell.data.showInPatientPortalTranslated }}</span>
                        </template>
                    </MdTable>
                </b-col>
            </b-row>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnpatientlist'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="gotoPatientPortal"
            />
            <b-dropdown
                id="dropdown-dropup"
                dropup
                :text="$tc('Shared.ActionsTxt', 2)"
                variant="primary"
                class="m-2"
                :disabled="!buttonActionEnabled"
            >
                <b-dropdown-item
                    href="#"
                    :disabled="setVisibleInPortalDisabled"
                    v-on:click="() => showClaimInPatientPortal(null, true)"
                >
                    {{ $t('PPDbClaims.ToggleShowToPatient') }}
                </b-dropdown-item>
                <b-dropdown-item
                    href="#"
                    :disabled="hideFromPortalDisabled"
                    v-on:click="() => showClaimInPatientPortal(null, false)"
                >
                    {{ $t('PPDbClaims.HideShowToPatient') }}
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <MDTextEditorDialog
            :visible="textEditorVisible"
            :value="textEditorValue"
            @close="closeTextEditorHandler"
            @ok="closeTextEditorHandler"
            :handlerOk="closeTextEditorHandler"
            :required="false"
            :buttonSaveHidden="true"
            :isReadOnly="true"
            :title="$t('PatientPortalDashboard.Title')"
        />

        <patient-portal-change-password
            :visible.sync="changePasswordVisible"
            :userName="selectedUserName"
        />

        <patient-portal-create-login
            :visible.sync="createLoginVisible"
            :patientCode="patientCodeFirstOrDefault"
            :fullName="selectedFullName"
            :email="selectedEmail"
            @ok="createLoginHandler"
        />

        <patient-portal-change-user-name
            :visible.sync="changeUserNameVisible"
            :patientCode="patientCodeFirstOrDefault"
            :fullName="selectedFullName"
            :userName="selectedUserName"
            @ok="createLoginHandler"
        />

        <patient-portal-notify
            :visible.sync="notifyVisible"
            :patientCodeList="selectedPatientCodeList"
            :notifyType="notifyType"
            :notifyTemplateList="
                notifyType === 'email' ? notifyEmailTemplateList : notifyTextTemplateList
            "
        />
    </div>
</template>

<script>
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';
import ClaimList from '@/services/claimlist.service';
import EnumService from '@/services/enum.service';
import PatientPortalsService from '@/services/patientportals.service';
import { patientsPortalStore } from '../patientsPortalStore';
import PatientsPortalBase from '../patientsPortalBase.vue';
import PatientPortalChangePassword from '../dialogs/patientPortalChangePassword.vue';
import PatientPortalCreateLogin from '../dialogs/patientPortalCreateLogin.vue';
import PatientPortalChangeUserName from '../dialogs/patientPortalChangeUserName.vue';
import PatientPortalNotify from '../dialogs/patientPortalNotify.vue';

export default {
    name: 'PatientsPortalClaims',
    extends: PatientsPortalBase,
    components: {
        PatientPortalChangePassword,
        PatientPortalCreateLogin,
        PatientPortalChangeUserName,
        PatientPortalNotify
    },
    data() {
        return {
            RightMenuList: JSON.parse(JSON.stringify(EnumService.PatientsPortalSummaryItems)),
            items: [],
            totalRows: 0,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            claimFields: [
                {
                    key: 'showInPatientPortalTranslated',
                    sortable: true,
                    label: this.$t('ActList.ShowToPatient'),
                    class: 'text-left'
                },
                {
                    key: 'sysDate',
                    sortable: true,
                    label: this.$t('Shared.CreatedOn'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'fullUserName',
                    sortable: true,
                    label: this.$t('Shared.CreatedBy'),
                    class: 'text-left'
                },
                {
                    key: 'issLineNo',
                    sortable: true,
                    label: this.$t('PatientClaimList.IssLineNo'),
                    class: 'text-left'
                },
                {
                    key: 'dateFrom',
                    sortable: true,
                    label: this.$t('Shared.datefrom'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'dateTo',
                    sortable: true,
                    label: this.$t('Shared.dateTo'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'posCode',
                    sortable: true,
                    label: this.$t('PatientClaimList.PosCode'),
                    class: 'text-left'
                },
                {
                    key: 'cptHcpcs',
                    sortable: true,
                    label: this.$t('PatientClaimList.CptHcpcs'),
                    class: 'text-left'
                },
                {
                    key: 'hcpcsCode',
                    sortable: true,
                    label: this.$t('Shared.HCPCSCode'),
                    class: 'text-left'
                },
                {
                    key: 'modifier1',
                    sortable: true,
                    label: this.$t('PatientClaimList.Modifier', { num: 1 }),
                    class: 'text-left'
                },
                {
                    key: 'modifier2',
                    sortable: true,
                    label: this.$t('PatientClaimList.Modifier', { num: 2 }),
                    class: 'text-left'
                },
                {
                    key: 'modifier3',
                    sortable: true,
                    label: this.$t('PatientClaimList.Modifier', { num: 3 }),
                    class: 'text-left'
                },
                {
                    key: 'modifier4',
                    sortable: true,
                    label: this.$t('PatientClaimList.Modifier', { num: 4 }),
                    class: 'text-left'
                },
                {
                    key: 'recId',
                    sortable: true,
                    label: this.$t('PatientClaimList.RecId'),
                    class: 'text-right hidden'
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: 'patientCode',
                    class: 'text-left hidden'
                },
                {
                    key: 'diagCode',
                    sortable: true,
                    label: this.$t('PatientClaimList.DiagCode'),
                    class: 'text-left'
                },
                {
                    key: 'fullDoctorName',
                    sortable: true,
                    label: this.$t('Shared.Provider'),
                    class: 'text-left'
                },
                {
                    key: 'dayUnit',
                    sortable: true,
                    label: this.$t('PatientClaimList.DayUnit'),
                    class: 'text-left'
                },
                {
                    key: 'charges',
                    sortable: true,
                    label: this.$t('Shared.Charges'),
                    class: 'text-left',
                    formatter: value => {
                        return '$' + parseFloat(value).toFixed(2);
                    }
                },
                {
                    key: 'paid',
                    sortable: true,
                    label: this.$t('PatientClaimList.Paid'),
                    class: 'text-left'
                },
                {
                    key: 'paidAmt',
                    sortable: true,
                    label: this.$t('PatientClaimList.PaidAmt'),
                    class: 'text-left'
                },

                {
                    key: 'primaryInsurance',
                    sortable: true,
                    label: this.$t('Shared.PrimaryInsurance'),
                    class: 'text-left'
                },
                {
                    key: 'primInsuranceNo',
                    sortable: true,
                    label: this.$t('Shared.PrimInsuranceNo'),
                    class: 'text-left'
                },
                {
                    key: 'secondaryInsurance',
                    sortable: true,
                    label: this.$t('Shared.SecondaryInsurance'),
                    class: 'text-left'
                },
                {
                    key: 'secInsuranceNo',
                    sortable: true,
                    label: this.$t('PatientClaimList.SecInsuranceNo'),
                    class: 'text-left'
                },
                {
                    key: 'tertiaryInsurance',
                    sortable: true,
                    label: this.$t('PatientClaimList.TertiaryInsurance'),
                    class: 'text-left'
                },
                {
                    key: 'terInsuranceNo',
                    sortable: true,
                    label: this.$t('PatientClaimList.TerInsuranceNo'),
                    class: 'text-left'
                },

                {
                    key: 'valueCode',
                    sortable: true,
                    label: this.$t('Shared.ValueCode'),
                    class: 'text-left'
                },
                {
                    key: 'conditionCode1',
                    sortable: true,
                    label: this.$t('PatientClaimList.ConditionCode', { num: 1 }),
                    class: 'text-left'
                },
                {
                    key: 'conditionCode2',
                    sortable: true,
                    label: this.$t('PatientClaimList.ConditionCode', { num: 2 }),
                    class: 'text-left'
                },
                {
                    key: 'conditionCode3',
                    sortable: true,
                    label: this.$t('PatientClaimList.ConditionCode', { num: 3 }),
                    class: 'text-left'
                },
                {
                    key: 'conditionCode4',
                    sortable: true,
                    label: this.$t('PatientClaimList.ConditionCode', { num: 4 }),
                    class: 'text-left'
                },
                {
                    key: 'conditionCode5',
                    sortable: true,
                    label: this.$t('PatientClaimList.ConditionCode', { num: 5 }),
                    class: 'text-left'
                },
                {
                    key: 'conditionCode6',
                    sortable: true,
                    label: this.$t('PatientClaimList.ConditionCode', { num: 6 }),
                    class: 'text-left'
                },
                {
                    key: 'conditionCode7',
                    sortable: true,
                    label: this.$t('PatientClaimList.ConditionCode', { num: 7 }),
                    class: 'text-left'
                },

                {
                    key: 'sendFlag',
                    sortable: true,
                    label: this.$t('PatientClaimList.SendFlag'),
                    class: 'text-left',
                    formatter: value => {
                        return value ? 'Y' : 'N';
                    }
                },
                {
                    key: 'paidFull',
                    sortable: true,
                    label: this.$t('PatientClaimList.PaidFull'),
                    class: 'text-left',
                    formatter: value => {
                        return value ? 'Y' : 'N';
                    }
                },
                {
                    key: 'printFlag',
                    sortable: true,
                    label: this.$t('PatientClaimList.PrintFlag'),
                    class: 'text-left'
                },
                {
                    key: 'Amtapproved',
                    sortable: true,
                    label: this.$t('PatientClaimList.Amtapproved'),
                    class: 'text-left'
                },
                {
                    key: 'tosCode',
                    sortable: true,
                    label: this.$t('PatientClaimList.TosCode'),
                    class: 'text-left'
                },
                {
                    key: 'unitPrice',
                    sortable: true,
                    label: this.$t('Shared.UnitPrice'),
                    class: 'text-left'
                },
                {
                    key: 'electronic',
                    sortable: true,
                    label: this.$t('PatientClaimList.Electronic'),
                    class: 'text-left'
                },
                {
                    key: 'repeatDone',
                    sortable: true,
                    label: this.$t('PatientClaimList.RepeatDone'),
                    class: 'text-left'
                },
                {
                    key: 'masterLineNo',
                    sortable: true,
                    label: this.$t('PatientClaimList.MasterLineNo'),
                    class: 'text-left'
                },
                {
                    key: 'datePaid',
                    sortable: true,
                    label: this.$t('PatientClaimList.DatePaid'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'generationType',
                    sortable: true,
                    label: this.$t('PatientClaimList.GenerationType'),
                    class: 'text-left'
                },
                {
                    key: 'chkno',
                    sortable: true,
                    label: this.$t('PatientClaimList.Chkno'),
                    class: 'text-left'
                },
                {
                    key: 'seqNo',
                    sortable: true,
                    label: this.$t('PatientClaimList.SeqNo'),
                    class: 'text-left'
                },
                {
                    key: 'diagInd',
                    sortable: true,
                    label: this.$t('PatientClaimList.DiagInd'),
                    class: 'text-left'
                },
                {
                    key: 'docInd',
                    sortable: true,
                    label: this.$t('PatientClaimList.DocInd'),
                    class: 'text-left'
                },
                {
                    key: 'valueCodeAmt',
                    sortable: true,
                    label: this.$t('PatientClaimList.ValueCodeAmt'),
                    class: 'text-left'
                },
                {
                    key: 'claimSource',
                    sortable: true,
                    label: this.$t('PatientClaimList.ClaimSource'),
                    class: 'text-left'
                },
                {
                    key: 'paymentPercent',
                    sortable: true,
                    label: this.$t('PatientClaimList.PaymentPercent'),
                    class: 'text-left'
                },
                {
                    key: 'facilityCode',
                    sortable: true,
                    label: this.$t('PatientClaimList.FacilityCode'),
                    class: 'text-left'
                }
            ],
            fieldsDateArr: ['sysDate', 'dateFrom', 'dateTo', 'datePaid'],
            showMessageIsEmpty: false,
            parameters: {
                searchCriteria: '',
                dateFrom: null,
                dateTo: null,
                insuranceCode: [],
                PatientCodeList: [],
                hideZeroBalance: true,
                hideVoid: true,
                hideShowInPortal: true,
                primaryPaid: false,
                secondaryPaid: false,
                tertiaryPaid: false
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            patientCode: this.$route.params.id,
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: '',
                activitytypename: '',
                startdatetime: '',
                ageFormatted: ''
            },
            isReadOnly: this.$store.state.isPatientPortalClaimsEHRReadOnly,
            isDateFromValid: false,
            isDateToValid: false,
            insuranceCodeModel: [],
            insuranceLookupFields: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description')
                },
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.Code')
                }
            ],
            patientCodeModel: [],
            patientAuxFields: ['lastname'],
            patientFieldsDate: ['dob'],
            patientLookupFields: [
                { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
                { key: 'lastname', sortable: true, label: this.$t('Shared.LastName') },
                { key: 'patientcode', sortable: true, label: this.$t('Shared.Code') },
                { key: 'dob', sortable: true, label: this.$t('Shared.Dob') },
                { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone') },
                { key: 'email', sortable: true, label: this.$t('Shared.Email') },
                { key: 'address1', sortable: true, label: this.$t('Shared.Address1') },
                { key: 'city', sortable: true, label: this.$t('Shared.City') },
                { key: 'state', sortable: true, label: this.$t('Shared.State') },
                { key: 'zip', sortable: true, label: this.$t('Shared.Zip') }
            ],
            customActionButtons: [
                {
                    id: 'set-visible-in-portal',
                    visible: this.setVisibleInPortalVisible,
                    icon: 'med-eye-open-fill',
                    handler: item => this.showClaimInPatientPortal(item, true),
                    class: item => (item.showInPatientPortal ? 'checkedBTN' : 'uncheckedBTN'),
                    tooltip: this.$t('PPDbClaims.ToggleShowToPatient')
                },
                {
                    id: 'hide-from-portal',
                    visible: this.hideFromPortalVisible,
                    icon: 'med-eye-open-fill',
                    handler: item => this.showClaimInPatientPortal(item, false),
                    class: item => (item.showInPatientPortal ? 'checkedBTN' : 'uncheckedBTN'),
                    tooltip: this.$t('PPDbClaims.HideShowToPatient')
                }
            ],
            tablist: [
                {
                    title: this.$t('PPDbClaims.TabSearchCriteria'),
                    link: '#claimsSearchCriteria',
                    active: true
                },
                {
                    title: this.$t('PPDbClaims.TabVisibilityFilters'),
                    link: '#claimsVisibilityFilters'
                },
                {
                    title: this.$t('PPDbClaims.TabPaymentStatusFilters'),
                    link: '#claimsPaymentStatusFilters'
                }
            ]
        };
    },
    computed: {
        isAllPatientsMode() {
            return !this.patientCode;
        },

        fields() {
            if (!this.isAllPatientsMode) {
                return this.claimFields;
            }

            return [
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$tc('Shared.Patient', 1),
                    class: 'text-left'
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-left'
                },
                ...this.claimFields.filter(field => field.key !== 'patientCode')
            ];
        },

        buttonActionEnabled() {
            return !this.isReadOnly && this.selectedItems.length !== 0;
        },

        setVisibleInPortalDisabled() {
            return (
                this.selectedItems.length === 0 ||
                this.selectedItems.every(item => !this.setVisibleInPortalVisible(item))
            );
        },

        hideFromPortalDisabled() {
            return (
                this.selectedItems.length === 0 ||
                this.selectedItems.every(item => !this.hideFromPortalVisible(item))
            );
        }
    },
    methods: {
        gotoPatientPortal() {
            this.$router.push({ name: 'patients-portal' });
        },

        selectionChanged(items) {
            this.selectedItems = items;
        },

        onSearchCriteriaChanged(criteria) {
            this.parameters.searchCriteria = criteria;
            this.searchClaims();
        },

        changeCheckbox() {
            this.$nextTick(() => this.searchClaims());
        },

        getInsuranceValues(value) {
            this.insuranceCodeModel = value || [];
            this.parameters.insuranceCode = value || [];
            this.searchClaims();
        },

        getPatientValues(value) {
            this.patientCodeModel = value || [];
            this.parameters.PatientCodeList = value || [];
            this.searchClaims();
        },

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        setVisibleInPortalVisible(item) {
            return !item.showInPatientPortal;
        },

        hideFromPortalVisible(item) {
            return !!item.showInPatientPortal;
        },

        showClaimInPatientPortal(item, showInPatientPortal) {
            const parameters = {
                claimCodeList: this.selectedItems.map(x => x.recId),
                ShowInPatientPortal: showInPatientPortal
            };

            if (item) {
                parameters.claimCodeList = [item.recId];
            }

            this.showClaimInPatientPortalAsync(parameters);
        },

        searchClaims() {
            this.currentPage = 1;
            this.$refs.claimsTable.clearSelection();
            this.listingAsync();
        },

        async getAllClaimsForSelectAll(searchCriteria) {
            const parameters = {
                searchCriteria:
                    searchCriteria !== undefined ? searchCriteria : this.parameters.searchCriteria,
                PageSize: this.perPage,
                PageNumber: this.currentPage,
                PatientCode: this.$route.params.id,
                PatientCodeList: this.parameters.PatientCodeList,
                DateTo: this.parameters.dateTo,
                DateFrom: this.parameters.dateFrom,
                StatusList: [],
                InsurancesList: [],
                PaymentsList: []
            };

            if (this.parameters.hideVoid) {
                parameters.StatusList.push('HIDEVOID');
            }
            if (this.parameters.hideZeroBalance) {
                parameters.StatusList.push('HIDEZEROBALANCE');
            }
            if (this.parameters.hideShowInPortal) {
                parameters.StatusList.push('HIDESHOWINPORTAL');
            }
            if (this.parameters.insuranceCode && this.parameters.insuranceCode.length > 0) {
                parameters.InsurancesList.push(...this.parameters.insuranceCode);
            }
            if (this.parameters.primaryPaid) {
                parameters.PaymentsList.push('PRIMARYPAID');
            }
            if (this.parameters.secondaryPaid) {
                parameters.PaymentsList.push('SECONDARYPAID');
            }
            if (this.parameters.tertiaryPaid) {
                parameters.PaymentsList.push('TERTIARYPAID');
            }

            const response = await ClaimList.getAll(parameters);

            if (response.status === 200 && response.data) {
                return response.data;
            }

            return [];
        },

        async listingAsync() {
            const parameters = {
                PageSize: this.perPage,
                PageNumber: this.currentPage,
                PatientCode: this.$route.params.id,
                PatientCodeList: this.parameters.PatientCodeList,
                DateTo: this.parameters.dateTo,
                DateFrom: this.parameters.dateFrom,
                SearchCriteria: this.parameters.searchCriteria,
                StatusList: [],
                InsurancesList: [],
                PaymentsList: []
            };

            if (this.parameters.hideVoid) {
                parameters.StatusList.push('HIDEVOID');
            }
            if (this.parameters.hideZeroBalance) {
                parameters.StatusList.push('HIDEZEROBALANCE');
            }
            if (this.parameters.hideShowInPortal) {
                parameters.StatusList.push('HIDESHOWINPORTAL');
            }
            if (this.parameters.insuranceCode && this.parameters.insuranceCode.length > 0) {
                parameters.InsurancesList.push(...this.parameters.insuranceCode);
            }
            if (this.parameters.primaryPaid) {
                parameters.PaymentsList.push('PRIMARYPAID');
            }
            if (this.parameters.secondaryPaid) {
                parameters.PaymentsList.push('SECONDARYPAID');
            }
            if (this.parameters.tertiaryPaid) {
                parameters.PaymentsList.push('TERTIARYPAID');
            }

            if (this.parameters.dateFrom && this.parameters.dateTo) {
                const result = Utils.validateDateRange(
                    this.parameters.dateFrom,
                    this.parameters.dateTo
                );

                if (!result.valid) {
                    this.isDateToValid = !result.fields.includes('toDate');
                    this.isDateFromValid = !result.fields.includes('fromDate');
                    this.showMessage(this.$tc('Msg.Error'), this.$t(result.message), 'error');
                    return;
                }
            } else {
                this.isDateToValid =
                    !this.parameters.dateTo || Utils.isValidDate(this.parameters.dateTo);
                this.isDateFromValid =
                    !this.parameters.dateFrom || Utils.isValidDate(this.parameters.dateFrom);

                if (!this.isDateToValid || !this.isDateFromValid) {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.CheckRedLabeledFields'),
                        'errorAutoHide'
                    );

                    return;
                }
            }

            await ClaimList.getAll(parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        const header = JSON.parse(headerString);
                        this.totalRows = header.TotalCount;
                    }

                    this.showMessageIsEmpty = this.totalRows === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async showClaimInPatientPortalAsync(parameters) {
            await ClaimList.toggleShowInPatientPortal(parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('Shared.SavedSuccessfully'),
                            'success'
                        );
                        this.$nextTick(() => this.searchClaims());
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        initialize() {
            Promise.allSettled([this.listingAsync()]);
        },

        getActiveElement() {
            return 'PPDB_PatientClaims';
        },

        createLoginHandler(item) {
            this.selectedItems = [item];
            this.enabledAllItems();
        },

        async loadPatientTitle(patientCode) {
            const infoList = await this.getInfoTitle(patientCode);
            if (infoList && infoList.length > 0) {
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0];
                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = `${firstname} ${lastname}`;
            }
        },

        async loadPortalPatient(patientCode) {
            const response = await PatientPortalsService.getAllDashboard({
                PageSize: 1,
                PageNumber: 1,
                PatientCodeList: [patientCode],
                status: null,
                portalStatus: null
            });
            if (response.status === 200 && response.data && response.data.length > 0) {
                this.selectedItems = response.data.filter(
                    x => x.patientCode.trim() === patientCode.trim()
                );
            }
        },

        enabledAllItems() {
            const item = this.selectedItems.length === 1 ? this.selectedItems[0] : null;
            this.RightMenuList.forEach(element => {
                let buttonEnabled = false;
                switch (element.value) {
                    case 'PPDB_CreateCredentials':
                        buttonEnabled =
                            item &&
                            item.portalStatus === 'Not Enrolled' &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email) &&
                            !!item.dob;
                        break;
                    case 'PPDB_CreateAuthLogins':
                        buttonEnabled =
                            item &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email);
                        break;
                    case 'PPDB_CreateLogin':
                        buttonEnabled =
                            item &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email);
                        break;
                    case 'PPDB_ChangeUsername':
                    case 'PPDB_ChangePassword':
                        buttonEnabled = item && !Utils.isNullOrEmptyString(item.userName);
                        break;
                    case 'PPDB_PatientForms':
                    case 'PPDB_PatientContacts':
                    case 'PPDB_PatientClaims':
                    case 'PPDB_PatientInfo':
                    case 'PPDB_Summary':
                    case 'PPDB_ChangePatInfo':
                    case 'PPDB_Messages':
                    case 'PPDB_PatientList':
                        buttonEnabled = true;
                        break;
                    case 'PPDB_EmailToPatient':
                        buttonEnabled = this.isNotify('email');
                        break;
                    case 'PPDB_TextToPatient':
                        buttonEnabled = this.isNotify('text');
                        break;
                    default:
                        break;
                }
                element.ReadOnly = !buttonEnabled;
            });

            this.OptionsRightMenu.visible = false;
            this.OptionsRightMenu.btnPatientsPortalDashboardVisible = true;
            this.OptionsRightMenu.ItemsList = this.RightMenuList;
            this.OptionsRightMenu.active_el = this.getActiveElement();
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
        }
    },

    async mounted() {
        const patientCode = this.patientCode;

        if (patientCode) {
            await this.$nextTick();
            EventBus.$emit('loadMenu', patientCode);
            try {
                const stored = patientsPortalStore.selectedItem;
                if (stored && stored.patientCode.trim() === patientCode.trim()) {
                    this.selectedItems = [stored];
                    patientsPortalStore.selectedItem = null;
                    await this.loadPatientTitle(patientCode);
                } else {
                    await Promise.all([
                        this.loadPatientTitle(patientCode),
                        this.loadPortalPatient(patientCode)
                    ]);
                }
            } catch (e) {
                // fall through to enabledAllItems with whatever data loaded
            }

            this.enabledAllItems();
        } else {
            this.OptionsRightMenu.visible = false;
            this.OptionsRightMenu.btnPatientsPortalDashboardVisible = false;
            this.OptionsRightMenu.ItemsList = [];
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
        }

        this.initialize();
    }
};
</script>
